<template>
  <div class="user-info">
    <Row>
      <Col span="12">
      <h5 class="username">{{ user.name }}</h5>
      </Col>
      <Col class="text-right" span="12">
      <Avatar :src="user.avatar" v-if="user.avatar" size="large" />
      <Icon type="ios-contact" v-else size="40" />
      </Col>
    </Row>
    <Divider />
    <Row>
      <Col class="label" span="3">手机</Col>
      <Col span="2">&nbsp;</Col>
      <Col class="value" span="18">{{ user.mobile }}</Col>
    </Row>
    <Row>
      <Col class="label" span="3">邮箱</Col>
      <Col span="2">&nbsp;</Col>
      <Col span="18">{{ user.email }}</Col>
    </Row>
    <Row>
      <Col span="24" style="text-align:center;"><i-button shape="circle" size="large" type="primary" @click="showChat()">发送消息
      </i-button></Col>
    </Row>
  </div>
</template>

<script>
import conf from "../conf";
import { MessageTargetType } from "../../../utils/ChatUtils";

const { ChatListUtils } = require("../../../utils/ChatUtils.js");

export default {
  name: "userInfo",
  props: ["user"],
  data() {
    return {
      host: conf.getHostUrl()
    };
  },
  methods: {
    // 打开一个聊天对话框
    showChat: function () {
      let self = this;
      let chat = ChatListUtils.resetChatList(
        self,
        self.user,
        conf.getHostUrl(),
        MessageTargetType.FRIEND
      );
      this.$store.commit("setCurrentChat", this.user);
      self.$router.push({
        path: "/index/chatBox/",
        query: { chat: chat }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-info {
  font-size: 16px;
  line-height: 200%;
  color: #666;

  .text-right {
    text-align: center;
  }

  .username {
    font-weight: bold;
    font-size: 20px;
  }

  .label {
    text-align: justify;
    text-align-last: justify;
    font-weight: bold;
  }
}
</style>
